var amdi18n={"__root":{"fetch_started":"Loading Open eCard supported cards & protocols","invalid_format":"Invalid format","fetch_succeeded":"Loaded Open eCard supported cards & protocols","fetch_failed":"Loading Open eCard supported cards and protocols failed"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/util/nls/OpeneCardUtil_strings.js
// module id = 181
// module chunks = 6